import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Phase 3.1 Tier 2 — "Don't see what you need?" form.
//
// AJAX-only: the marketplace stays open and a toast confirms. The
// controller keeps the modal closeable via backdrop click + the
// Cancel button + the X button, all wired through `closeModal`.
export default class extends Controller {
  static targets = ["modal", "form", "submit"]

  openModal() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("hidden")
  }

  closeModal() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async submit(event) {
    event.preventDefault()
    if (!this.hasFormTarget) return
    const form = this.formTarget
    const submit = this.hasSubmitTarget ? this.submitTarget : null
    const originalLabel = submit ? submit.value : null

    if (submit) {
      submit.disabled = true
      submit.value = "Submitting…"
    }

    try {
      const formData = new FormData(form)
      const csrfMeta = document.querySelector('meta[name="csrf-token"]')
      const headers = { Accept: "application/json" }
      if (csrfMeta) headers["X-CSRF-Token"] = csrfMeta.content

      const res = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers,
        credentials: "same-origin"
      })

      let payload = null
      try { payload = await res.json() } catch (_e) { payload = null }

      if (res.ok && payload && payload.ok) {
        this.closeModal()
        form.reset()
        this._showToast(payload.message || "Request received.", "notice")
        track("Integration Requested", {
          kind: "custom",
          urgency: this._readUrgency(form)
        })
      } else {
        const message =
          (payload && payload.message) ||
          "We couldn't save your request. Please try again."
        this._showToast(message, "alert")
      }
    } catch (e) {
      this._showToast("Network error — please try again.", "alert")
    } finally {
      if (submit) {
        submit.disabled = false
        if (originalLabel) submit.value = originalLabel
      }
    }
  }

  // ── Internals ──────────────────────────────────────────────────

  _readUrgency(form) {
    const checked = form.querySelector('input[name="integration_request[urgency]"]:checked')
    return checked ? checked.value : null
  }

  _showToast(message, type) {
    const toast = document.createElement("div")
    const cls = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    toast.className = cls
    toast.setAttribute("data-controller", "flash")
    toast.setAttribute("data-flash-dismiss-after-value", "5000")
    toast.textContent = message
    document.body.prepend(toast)
  }
}
